<div class="loader-wrapper" [ngClass]="{'d-none': !isLoading}">
  <span class="loader"></span>
</div>
